module.exports = __webpack_public_path__ + "img/img3.137b5952.jpg";